export const reincidenceDefault = {block: '1', reincidence: '2'}